import { MarkAsReadBulk } from './MarkAsReadBulk'

export default MarkAsReadBulk
